import React from "react";

const Answer = ({ children, className }) => {
  const cls = className
    ? `performance-qa-answer rounded-lg ${className}`
    : "performance-qa-answer rounded-lg";
  return <div className={cls}>{children}</div>;
};

export default Answer;
